function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#D6F3F5",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.704 14.354l4.266-5.43a.6.6 0 00-.472-.97H5.967a.6.6 0 00-.472.97l4.266 5.43a.6.6 0 00.943 0z",
  fill: "#31C4CC"
}));

var SvgBtnWorkMoreClick = function SvgBtnWorkMoreClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
};

export default SvgBtnWorkMoreClick;